import {
  LOAD_TRUCKENGINEOFF,
  LOAD_VEHICLE_TRUCKENGINEOFF,
  LOAD_VEHICLE_TYPE_TRUCKENGINEOFF
} from "./actions";

const initialState = {
  truckengineoffUrl: "",
  vehicleLists: [],
  vehicleTypeLists: [],
  truckengineoffLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TRUCKENGINEOFF.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        truckengineoffLoading: loading
      };
    case LOAD_TRUCKENGINEOFF.SUCCESS:

      return {
        ...state,
        truckengineoffUrl: action.payload.data.data,
        truckengineoffLoading: false
      };
    case LOAD_VEHICLE_TRUCKENGINEOFF.REQUEST:
      const { loading_vehicle } = action.payload;
      return {
        ...state,
        truckengineoffLoading: loading_vehicle
      };
    case LOAD_VEHICLE_TRUCKENGINEOFF.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        truckengineoffLoading: false
      };
    case LOAD_VEHICLE_TYPE_TRUCKENGINEOFF.SUCCESS:
      return {
        ...state,
        vehicleTypeLists: action.payload.data.data
      };
    default:
      return state;
  }
};
